<div class="page-body-wrapper">
    <div class="row">
        <div class="col-lg-12">
            <div>
                <button mat-raised-button color="primary" (click)="openOvertimeCreateModal(true)">
                    <mat-icon>add</mat-icon>
                    <span>Fazla Mesai Talebi</span>
                </button>
            </div>

            <mat-tab-group [selectedIndex]="selectedTab">
                <mat-tab label="Onay Bekleyenler" *ngIf="currentUser.manager || currentUser.hr">
                    <div class="table-responsive table-hidden-scroll" style="overflow-x:hidden">
                        <div class="row filter-wrapper">
                            <div class="col-lg-2">
                                <mat-form-field class="overtime-form-field">
                                    <mat-label>Mesai Türü Seçiniz</mat-label>
                                    <mat-select [(value)]="selectedovertimeType1">
                                        <mat-option *ngFor="let overtimeType of overtimeTypeList"
                                            [value]="overtimeType">
                                            {{overtimeType.description}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3">
                                <mat-form-field class="overtime-form-field">
                                    <mat-label>Departman Seçiniz</mat-label>
                                    <mat-select [(value)]="selectedDepartment1">
                                        <mat-option *ngFor="let department of departmentList" [value]="department">
                                            {{department.lookupValue ? (department.lookupValue + ' - ' + department.description) : department.description}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-2">
                                <mat-form-field class="overtime-form-field">
                                    <mat-label>Başlangıç Tarihi</mat-label>
                                    <input readonly matInput [matDatepicker]="pickerStart1"
                                        [formControl]="startDateFilterValue1" style="max-width: 160px;">
                                    <mat-datepicker-toggle matSuffix [for]="pickerStart1"></mat-datepicker-toggle>
                                    <mat-datepicker startView="multi-year" #pickerStart1></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-2">
                                <mat-form-field class="overtime-form-field">
                                    <mat-label>Bitiş Tarihi</mat-label>
                                    <input readonly matInput [matDatepicker]="pickerEnd1"
                                        [formControl]="endDateFilterValue1">
                                    <mat-datepicker-toggle matSuffix [for]="pickerEnd1"></mat-datepicker-toggle>
                                    <mat-datepicker #pickerEnd1 startView="multi-year"></mat-datepicker>
                                </mat-form-field>
                            </div>

                            <div class="col-lg-2">
                                <div class="form-group">
                                    <mat-form-field class="overtime-form-field">
                                        <mat-label>Şube </mat-label>
                                        <mat-select [(value)]="selectedOvertimeBranch1">
                                            <mat-option *ngFor="let overtimeBranch of overtimeBranchList"
                                                [value]="overtimeBranch">
                                                {{overtimeBranch.description}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="col-lg-2">
                                <div class="form-group">
                                    <mat-form-field class="overtime-form-field">
                                        <mat-label>Proje</mat-label>
                                        <mat-select [(value)]="selectedOvertimeProject1"
                                            (selectionChange)="overtimeProjectChanged()">
                                            <mat-option *ngFor="let overtimeProject of overtimeProjectList"
                                                [value]="overtimeProject">
                                                {{overtimeProject.description}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="col-lg-2" *ngIf="selectedOvertimeProject1?.attribute2=='Y'">
                                <div class="form-group">
                                    <mat-form-field class="overtime-form-field"
                                        *ngIf="selectedOvertimeProject1?.attribute2=='Y'">
                                        <mat-label>Kiracı</mat-label>
                                        <mat-select [(value)]="selectedOvertimeTenant1">
                                            <mat-option *ngFor="let overtimeTenant of overtimeTenantList"
                                                [value]="overtimeTenant">
                                                {{overtimeTenant.description}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="col-lg-2">
                                <mat-form-field style="width: 100%;">
                                    <mat-label>Ad Soyad</mat-label>
                                    <input matInput placeholder="" [(ngModel)]="searchFullName1">
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3 table-header-button-wrapper">
                                <button mat-raised-button color="warn" (click)="filterGrid(0, 'ONAY_BEKLEYENLER')"
                                    style="margin-right: 5px;">Filtrele</button>
                                <button mat-raised-button color="link" (click)="clearfilterGrid(0, 'ONAY_BEKLEYENLER')"
                                    style="margin-right: 5px;">Temizle</button>
                                <div class="excel-export-button" matTooltip="Excele aktar"
                                    (click)="reportTab(0, 'ONAY_BEKLEYEN_FAZLA_MESAILER')">
                                    <fa-icon [icon]="fileExcelIcon" class="excel-icon"></fa-icon>
                                </div>
                            </div>

                        </div>
                        <mat-table matTableExporter #waitingsExporter="matTableExporter" [hiddenColumns]="[0,9]"
                            class="lessons-table mat-elevation-z8" #WaitingSort="matSort" matSort
                            [dataSource]="dsWaitings" (matSortChange)="sortChangeOfWaitings($event)">
                            <!-- Checkbox Column -->
                            <ng-container matColumnDef="select">
                                <th mat-header-cell *matHeaderCellDef class="table-checkbox">
                                    <mat-checkbox (change)="$event ? masterToggle() : null"
                                        [checked]="selection.hasValue() && isAllSelected()"
                                        [indeterminate]="selection.hasValue() && !isAllSelected()">
                                    </mat-checkbox>
                                </th>
                                <td mat-cell *matCellDef="let row" class="table-checkbox">
                                    <mat-checkbox (click)="$event.stopPropagation()"
                                        (change)="$event ? selection.toggle(row) : null"
                                        [checked]="selection.isSelected(row)">
                                    </mat-checkbox>
                                </td>
                            </ng-container>
                            <!-- <ng-container matColumnDef="isCompleted">
                              <mat-header-cell *matHeaderCellDef style="flex-grow: 0"> Durum </mat-header-cell>
                              <mat-cell *matCellDef="let element" style="flex-grow: 0">{{element.isCompleted == 1 ? 'onay' : element.isCompleted == -1 ? 'red' : 'bekliyor'}}</mat-cell>
                          </ng-container>-->
                            <ng-container matColumnDef="name">
                                <mat-header-cell *matHeaderCellDef mat-sort-header> Adı Soyadı </mat-header-cell>
                                <mat-cell *matCellDef="let element">{{element.name}} {{element.surname}}</mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="departmentName">
                                <mat-header-cell *matHeaderCellDef> Departman </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.departmentName}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="overtimeTypeName">
                                <mat-header-cell *matHeaderCellDef> Mesai Türü </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.overtimeTypeName}} </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="overtimeDay">
                                <mat-header-cell *matHeaderCellDef style="flex-grow: 0.5"> Mesai <br> Süresi
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element" style="flex-grow: 0.5"> {{element.overtimeHours}}
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="freeDayAmount">
                                <mat-header-cell *matHeaderCellDef style="flex-grow: 0.5"> Tatil <br> Günü
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element" style="flex-grow: 0.5"> {{element.isRestDay == 1 ?
                                    'Evet' : 'Hayır'}}
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="overtimeStartDate">
                                <mat-header-cell *matHeaderCellDef mat-sort-header style="flex-grow: 0.75"> Başlangıç
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element" style="flex-grow: 0.75"> {{element.overtimeStartDate
                                    | customDate}} </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="overtimeEndDate">
                                <mat-header-cell *matHeaderCellDef mat-sort-header style="flex-grow: 0.75">Bitiş
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element" style="flex-grow: 0.75"> {{element.overtimeEndDate |
                                    customDate}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="description">
                                <mat-header-cell *matHeaderCellDef style="flex-grow: 1.25"> Açıklama</mat-header-cell>
                                <mat-cell *matCellDef="let element" class="long-text-content" style="flex-grow: 1.25">
                                    <span class="text-truncate">{{element.description}}</span> </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="branchName">
                                <mat-header-cell *matHeaderCellDef style="flex-grow: 1.25"> Şube</mat-header-cell>
                                <mat-cell *matCellDef="let element" class="long-text-content" style="flex-grow: 1.25">
                                    <span class="text-truncate">{{element.branchName}}</span> </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="projectName">
                                <mat-header-cell *matHeaderCellDef style="flex-grow: 1.25"> Proje</mat-header-cell>
                                <mat-cell *matCellDef="let element" class="long-text-content" style="flex-grow: 1.25">
                                    <span class="text-truncate">{{element.projectName}}</span> </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="actions">
                                <mat-header-cell *matHeaderCellDef class="actions-mat-cell"
                                    style="flex-grow: 1.25"></mat-header-cell>
                                <mat-cell *matCellDef="let element" class="actions-mat-cell" style="flex-grow: 1.25">
                                    <div class="action-buttons-container">
                                        <button mat-icon-button matTooltip="Güncelle" class="action-button edit-button"
                                            (click)="openUpdateModal(element, 1)">
                                            <mat-icon>edit</mat-icon>
                                        </button>
                                        <button mat-icon-button matTooltip="Detay" class="action-button detail-button"
                                            (click)="openDetail(element)">
                                            <mat-icon>insert_comment</mat-icon>
                                        </button>
                                        <button mat-icon-button matTooltip="Onayla" class="action-button approve-button"
                                            (click)="openApproveModal(element)">
                                            <mat-icon>done_outline</mat-icon>
                                        </button>
                                        <button mat-icon-button matTooltip="Reddet" class="action-button reject-button"
                                            (click)="openRejectModal(element)">
                                            <mat-icon>highlight_off</mat-icon>
                                        </button>
                                    </div>
                                </mat-cell>
                            </ng-container>
                            <mat-header-row *matHeaderRowDef="displayedColumnsWaiting"></mat-header-row>
                            <mat-row *matRowDef="let row; columns: displayedColumnsWaiting"></mat-row>

                        </mat-table>
                        <mat-paginator [pageSizeOptions]="[20]" (page)="pageEventOfWaitings($event)"
                            #waitingsPaginator='matPaginator' showFirstLastButtons></mat-paginator>
                        <div class="col-lg-3" style="margin-top: 5px;margin-bottom: auto;padding-left: 0 !important;">
                            <button [disabled]="!selection.hasValue()" mat-raised-button color="warn"
                                (click)="openRejectSelectedModal()" style="margin-right: 5px;">Reddet</button>
                            <button [disabled]="!selection.hasValue()" mat-raised-button color="primary"
                                (click)="openApproveSelectedModal()" style="margin-right: 5px;">Onayla</button>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Mesailerim">

                    <div class="table-responsive table-hidden-scroll" style="overflow-x:hidden">

                        <div class="row filter-wrapper">
                            <div class="col-lg-2">
                                <mat-form-field class="overtime-form-field">
                                    <mat-label>Mesai Türü Seçiniz</mat-label>
                                    <mat-select [(value)]="selectedovertimeType2">
                                        <mat-option *ngFor="let overtimeType of overtimeTypeList"
                                            [value]="overtimeType.description">
                                            {{overtimeType.description}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3">
                                <mat-form-field class="overtime-form-field">
                                    <mat-label>Departman Seçiniz</mat-label>
                                    <mat-select [(value)]="selectedDepartment2">
                                        <mat-option *ngFor="let department of departmentList"
                                            [value]="department.description">
                                            {{department.lookupValue ? (department.lookupValue + ' - ' + department.description) : department.description}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-2">
                                <mat-form-field class="overtime-form-field">
                                    <mat-label>Başlangıç Tarihi</mat-label>
                                    <input readonly matInput [matDatepicker]="pickerStart2"
                                        [formControl]="startDateFilterValue2" style="max-width: 160px;">
                                    <mat-datepicker-toggle matSuffix [for]="pickerStart2"></mat-datepicker-toggle>
                                    <mat-datepicker startView="multi-year" #pickerStart2></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-2">
                                <mat-form-field class="overtime-form-field">
                                    <mat-label>Bitiş Tarihi</mat-label>
                                    <input readonly matInput [matDatepicker]="pickerEnd2"
                                        [formControl]="endDateFilterValue2">
                                    <mat-datepicker-toggle matSuffix [for]="pickerEnd2"></mat-datepicker-toggle>
                                    <mat-datepicker #pickerEnd2 startView="multi-year"></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-2">
                                <div class="form-group">
                                    <mat-form-field class="overtime-form-field">
                                        <mat-label>Şube </mat-label>
                                        <mat-select [(value)]="selectedOvertimeBranch2">
                                            <mat-option *ngFor="let overtimeBranch of overtimeBranchList"
                                                [value]="overtimeBranch">
                                                {{overtimeBranch.description}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="col-lg-2">
                                <div class="form-group">
                                    <mat-form-field class="overtime-form-field">
                                        <mat-label>Proje</mat-label>
                                        <mat-select [(value)]="selectedOvertimeProject2"
                                            (selectionChange)="overtimeProjectChanged()">
                                            <mat-option *ngFor="let overtimeProject of overtimeProjectList"
                                                [value]="overtimeProject">
                                                {{overtimeProject.description}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="col-lg-2" *ngIf="selectedOvertimeProject2?.attribute2=='Y'">
                                <div class="form-group">
                                    <mat-form-field class="overtime-form-field"
                                        *ngIf="selectedOvertimeProject2?.attribute2=='Y'">
                                        <mat-label>Kiracı</mat-label>
                                        <mat-select [(value)]="selectedOvertimeTenant2">
                                            <mat-option *ngFor="let overtimeTenant of overtimeTenantList"
                                                [value]="overtimeTenant">
                                                {{overtimeTenant.description}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="col-lg-2">
                                <mat-form-field style="width: 100%;">
                                    <mat-label>Ad Soyad</mat-label>
                                    <input matInput placeholder="" [(ngModel)]="searchFullName2">
                                </mat-form-field>
                            </div>
                            <div class="col-lg-2 table-header-button-wrapper">
                                <button mat-raised-button color="warn" (click)="filterGrid(1, 'TALEPLERIM')"
                                    style="margin-right: 5px;">Filtrele</button>
                                <button mat-raised-button color="link" (click)="clearfilterGrid(1, 'TALEPLERIM')"
                                    style="margin-right: 5px;">Temizle</button>
                                <div class="excel-export-button" matTooltip="Excele aktar"
                                    (click)="reportTab(1, 'FAZLA_MESAILERIM')">
                                    <fa-icon [icon]="fileExcelIcon" class="excel-icon"></fa-icon>
                                </div>
                            </div>
                        </div>

                        <mat-table matTableExporter #exporter2="matTableExporter" [hiddenColumns]="[9]" id="taleplerim"
                            #MyRequestSort="matSort" matSort class="lessons-table mat-elevation-z8"
                            [dataSource]="dsMyRequest" (matSortChange)="sortChangeOfMyRequest($event)">
                            <ng-container matColumnDef="isCompleted">
                                <mat-header-cell *matHeaderCellDef> Durum </mat-header-cell>
                                <mat-cell *matCellDef="let element" [ngStyle]="{'color' : element.isCompleted == 1 ? 'green' :
                                                              element.isCompleted == -1 ? 'red' :
                                                              'gray'}">
                                    {{element.isCompleted == 1 ? 'Onaylandı' : element.isCompleted == -1 ? 'Reddedildi'
                                    : 'Bekliyor'}}
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="name">
                                <mat-header-cell *matHeaderCellDef mat-sort-header> Adı Soyadı </mat-header-cell>
                                <mat-cell *matCellDef="let element">{{element.name}} {{element.surname}}</mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="departmentName">
                                <mat-header-cell *matHeaderCellDef> Departman </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.departmentName}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="overtimeTypeName">
                                <mat-header-cell *matHeaderCellDef> Mesai Türü </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.overtimeTypeName}} </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="overtimeDay">
                                <mat-header-cell *matHeaderCellDef style="flex-grow: 0.5"> Mesai <br> Süresi
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element" style="flex-grow: 0.5"> {{element.overtimeHours}}
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="freeDayAmount">
                                <mat-header-cell *matHeaderCellDef style="flex-grow: 0.5"> Tatil <br> Günü
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element" style="flex-grow: 0.5"> {{element.isRestDay == 1 ?
                                    'Evet' : 'Hayır'}}
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="overtimeStartDate">
                                <mat-header-cell *matHeaderCellDef mat-sort-header> Başlangıç </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.overtimeStartDate | customDate}}
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="overtimeEndDate">
                                <mat-header-cell *matHeaderCellDef mat-sort-header> Bitiş </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.overtimeEndDate | customDate}}
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="description">
                                <mat-header-cell *matHeaderCellDef style="flex-grow: 2"> Açıklama</mat-header-cell>
                                <mat-cell *matCellDef="let element" style="flex-grow: 2" class="long-text-content"><span
                                        class="text-truncate">{{element.description}}</span> </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="branchName">
                                <mat-header-cell *matHeaderCellDef style="flex-grow: 1.25"> Şube</mat-header-cell>
                                <mat-cell *matCellDef="let element" class="long-text-content" style="flex-grow: 1.25">
                                    <span class="text-truncate">{{element.branchName}}</span> </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="projectName">
                                <mat-header-cell *matHeaderCellDef style="flex-grow: 1.25"> Proje</mat-header-cell>
                                <mat-cell *matCellDef="let element" class="long-text-content" style="flex-grow: 1.25">
                                    <span class="text-truncate">{{element.projectName}}</span> </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="actions">
                                <mat-header-cell *matHeaderCellDef class="actions-mat-cell"
                                    style="flex-grow: 1 !important;">
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element" class="actions-mat-cell"
                                    style="flex-grow: 1 !important;">
                                    <div class="action-buttons-container">
                                        <!-- bekliyor durumunda ise yani islem yapilmadi ise guncelleme yapilabilir -->
                                        <button mat-icon-button matTooltip="Güncelle"
                                            *ngIf="(element.isCompleted == null || element.isCompleted == 0) && element.anyManagerApproved == 0"
                                            class="action-button edit-button" (click)="openUpdateModal(element, 2)">
                                            <mat-icon>edit</mat-icon>
                                        </button>
                                        <button mat-icon-button matTooltip="Yenile ve Tekrar Gönder"
                                            *ngIf="element.isCompleted == -1" class="action-button refresh-button"
                                            (click)="openOvertimeCreateModal(false, element)">
                                            <mat-icon>cached</mat-icon>
                                        </button>
                                        <button mat-icon-button matTooltip="Detay" class="action-button detail-button"
                                            (click)="openDetail(element)">
                                            <mat-icon>insert_comment</mat-icon>
                                        </button>
                                        <button mat-icon-button matTooltip="İzni Silin"
                                            *ngIf="element.isCompleted == null && element.anyManagerApproved == 0"
                                            class="action-button delete-button" (click)="openDeleteModal(element)">
                                            <mat-icon>delete_forever</mat-icon>
                                        </button>
                                    </div>
                                </mat-cell>
                            </ng-container>
                            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>

                        </mat-table>
                        <mat-paginator [pageSizeOptions]="[20]" (page)="pageEventOfMyRequests($event)"
                            #myRequestPaginator="matPaginator" showFirstLastButtons></mat-paginator>
                    </div>
                </mat-tab>
                <mat-tab label="Onayladıklarım" *ngIf="currentUser.manager || currentUser.hr">
                    <div class="table-responsive table-hidden-scroll" style="overflow-x:hidden">

                        <div class="row filter-wrapper">
                            <div class="col-lg-2">
                                <mat-form-field class="overtime-form-field">
                                    <mat-label>Mesai Türü Seçiniz</mat-label>
                                    <mat-select [(value)]="selectedovertimeType3">
                                        <mat-option *ngFor="let overtimeType of overtimeTypeList"
                                            [value]="overtimeType.description">
                                            {{overtimeType.description}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3">
                                <mat-form-field class="overtime-form-field">
                                    <mat-label>Departman Seçiniz</mat-label>
                                    <mat-select [(value)]="selectedDepartment3">
                                        <mat-option *ngFor="let department of departmentList"
                                            [value]="department.description">
                                            {{department.lookupValue ? (department.lookupValue + ' - ' + department.description) : department.description}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-2">
                                <mat-form-field class="overtime-form-field">
                                    <mat-label>Başlangıç Tarihi</mat-label>
                                    <input readonly matInput [matDatepicker]="pickerStart3"
                                        [formControl]="startDateFilterValue3" style="max-width: 160px;">
                                    <mat-datepicker-toggle matSuffix [for]="pickerStart3"></mat-datepicker-toggle>
                                    <mat-datepicker startView="multi-year" #pickerStart3></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-2">
                                <mat-form-field class="overtime-form-field">
                                    <mat-label>Bitiş Tarihi</mat-label>
                                    <input readonly matInput [matDatepicker]="pickerEnd3"
                                        [formControl]="endDateFilterValue3">
                                    <mat-datepicker-toggle matSuffix [for]="pickerEnd3"></mat-datepicker-toggle>
                                    <mat-datepicker #pickerEnd3 startView="multi-year"></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-2">
                                <div class="form-group">
                                    <mat-form-field class="overtime-form-field">
                                        <mat-label>Şube </mat-label>
                                        <mat-select [(value)]="selectedOvertimeBranch4">
                                            <mat-option *ngFor="let overtimeBranch of overtimeBranchList"
                                                [value]="overtimeBranch">
                                                {{overtimeBranch.description}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="col-lg-2">
                                <div class="form-group">
                                    <mat-form-field class="overtime-form-field">
                                        <mat-label>Proje</mat-label>
                                        <mat-select [(value)]="selectedOvertimeProject4"
                                            (selectionChange)="overtimeProjectChanged()">
                                            <mat-option *ngFor="let overtimeProject of overtimeProjectList"
                                                [value]="overtimeProject">
                                                {{overtimeProject.description}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="col-lg-2" *ngIf="selectedOvertimeProject4?.attribute2=='Y'">
                                <div class="form-group">
                                    <mat-form-field class="overtime-form-field"
                                        *ngIf="selectedOvertimeProject4?.attribute2=='Y'">
                                        <mat-label>Kiracı</mat-label>
                                        <mat-select [(value)]="selectedOvertimeTenant4">
                                            <mat-option *ngFor="let overtimeTenant of overtimeTenantList"
                                                [value]="overtimeTenant">
                                                {{overtimeTenant.description}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="col-lg-2">
                                <mat-form-field style="width: 100%;">
                                    <mat-label>Ad Soyad</mat-label>
                                    <input matInput placeholder="" [(ngModel)]="searchFullName3">
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3 table-header-button-wrapper">
                                <button mat-raised-button color="warn" (click)="filterGrid(2, 'ONAYLADIKLARIM')"
                                    style="margin-right: 5px;">Filtrele</button>
                                <button mat-raised-button color="link" (click)="clearfilterGrid(2, 'ONAYLADIKLARIM')"
                                    style="margin-right: 5px;">Temizle</button>
                                <div class="excel-export-button" matTooltip="Excele aktar"
                                    (click)="reportTab(2, 'ONAYLADIGIM_FAZLA_MESAILER')">
                                    <fa-icon [icon]="fileExcelIcon" class="excel-icon"></fa-icon>
                                </div>
                            </div>
                        </div>

                        <mat-table matTableExporter #exporter3="matTableExporter" [hiddenColumns]="[9]"
                            #ApprovalSort="matSort" matSort class="lessons-table mat-elevation-z8"
                            [dataSource]="dsMyApprovals" (matSortChange)="sortChangeOfApprovals($event)">
                            <ng-container matColumnDef="isCompleted">
                                <mat-header-cell *matHeaderCellDef> Durum </mat-header-cell>
                                <mat-cell *matCellDef="let element" [ngStyle]="{'color' : element.isCompleted == 1 ? 'green' :
                                                              element.isCompleted == -1 ? 'red' :
                                                              'gray'}">
                                    {{element.isCompleted == 1 ? 'Onaylandı' : element.isCompleted == -1 ? 'Reddedildi'
                                    : 'Bekliyor'}}
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="name">
                                <mat-header-cell *matHeaderCellDef mat-sort-header> Adı Soyadı </mat-header-cell>
                                <mat-cell *matCellDef="let element">{{element.name}} {{element.surname}}</mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="departmentName">
                                <mat-header-cell *matHeaderCellDef> Departman </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.departmentName}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="overtimeTypeName">
                                <mat-header-cell *matHeaderCellDef> Mesai Türü </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.overtimeTypeName}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="overtimeDay">
                                <mat-header-cell *matHeaderCellDef style="flex-grow: 0.5"> Mesai <br> Süresi
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element" style="flex-grow: 0.5"> {{element.overtimeHours}}
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="freeDayAmount">
                                <mat-header-cell *matHeaderCellDef style="flex-grow: 0.5"> Tatil <br> Günü
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element" style="flex-grow: 0.5"> {{element.isRestDay == 1 ?
                                    'Evet' : 'Hayır'}}
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="overtimeStartDate">
                                <mat-header-cell *matHeaderCellDef mat-sort-header> Başlangıç </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.overtimeStartDate | customDate}}
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="overtimeEndDate">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>Bitiş </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.overtimeEndDate}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="description">
                                <mat-header-cell *matHeaderCellDef> Açıklama</mat-header-cell>
                                <mat-cell *matCellDef="let element" class="long-text-content"><span
                                        class="text-truncate">{{element.description}}</span> </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="branchName">
                                <mat-header-cell *matHeaderCellDef style="flex-grow: 1.25"> Şube</mat-header-cell>
                                <mat-cell *matCellDef="let element" class="long-text-content" style="flex-grow: 1.25">
                                    <span class="text-truncate">{{element.branchName}}</span> </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="projectName">
                                <mat-header-cell *matHeaderCellDef style="flex-grow: 1.25"> Proje</mat-header-cell>
                                <mat-cell *matCellDef="let element" class="long-text-content" style="flex-grow: 1.25">
                                    <span class="text-truncate">{{element.projectName}}</span> </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="actions">
                                <mat-header-cell *matHeaderCellDef class="actions-mat-cell"></mat-header-cell>
                                <mat-cell *matCellDef="let element" class="actions-mat-cell">
                                    <div class="action-buttons-container">
                                        <button mat-icon-button matTooltip="Detay" class="action-button detail-button"
                                            (click)="openDetail(element)">
                                            <mat-icon>insert_comment</mat-icon>
                                        </button>
                                    </div>
                                </mat-cell>
                            </ng-container>
                            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>

                        </mat-table>
                        <mat-paginator [pageSizeOptions]="[20]" (page)="pageEventOfApprovals($event)"
                            #myApprovalsPaginator='matPaginator' showFirstLastButtons></mat-paginator>
                    </div>
                </mat-tab>
                <mat-tab label="Reddettiklerim" *ngIf="currentUser.manager || currentUser.hr">
                    <div class="table-responsive table-hidden-scroll" style="overflow-x:hidden">

                        <div class="row filter-wrapper">
                            <div class="col-lg-2">
                                <mat-form-field class="overtime-form-field">
                                    <mat-label>Mesai Türü Seçiniz</mat-label>
                                    <mat-select [(value)]="selectedovertimeType4">
                                        <mat-option *ngFor="let overtimeType of overtimeTypeList"
                                            [value]="overtimeType.description">
                                            {{overtimeType.description}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3">
                                <mat-form-field class="overtime-form-field">
                                    <mat-label>Departman Seçiniz</mat-label>
                                    <mat-select [(value)]="selectedDepartment4">
                                        <mat-option *ngFor="let department of departmentList"
                                            [value]="department.description">
                                            {{department.lookupValue ? (department.lookupValue + ' - ' + department.description) : department.description}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-2">
                                <mat-form-field class="overtime-form-field">
                                    <mat-label>Başlangıç Tarihi</mat-label>
                                    <input readonly matInput [matDatepicker]="pickerStart4"
                                        [formControl]="startDateFilterValue4" style="max-width: 160px;">
                                    <mat-datepicker-toggle matSuffix [for]="pickerStart4"></mat-datepicker-toggle>
                                    <mat-datepicker startView="multi-year" #pickerStart4></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-2">
                                <mat-form-field class="overtime-form-field">
                                    <mat-label>Bitiş Tarihi</mat-label>
                                    <input readonly matInput [matDatepicker]="pickerEnd4"
                                        [formControl]="endDateFilterValue4">
                                    <mat-datepicker-toggle matSuffix [for]="pickerEnd4"></mat-datepicker-toggle>
                                    <mat-datepicker #pickerEnd4 startView="multi-year"></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-2">
                                <div class="form-group">
                                    <mat-form-field class="overtime-form-field">
                                        <mat-label>Şube </mat-label>
                                        <mat-select [(value)]="selectedOvertimeBranch5">
                                            <mat-option *ngFor="let overtimeBranch of overtimeBranchList"
                                                [value]="overtimeBranch">
                                                {{overtimeBranch.description}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="col-lg-2">
                                <div class="form-group">
                                    <mat-form-field class="overtime-form-field">
                                        <mat-label>Proje</mat-label>
                                        <mat-select [(value)]="selectedOvertimeProject5"
                                            (selectionChange)="overtimeProjectChanged()">
                                            <mat-option *ngFor="let overtimeProject of overtimeProjectList"
                                                [value]="overtimeProject">
                                                {{overtimeProject.description}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="col-lg-2" *ngIf="selectedOvertimeProject5?.attribute2=='Y'">
                                <div class="form-group">
                                    <mat-form-field class="overtime-form-field"
                                        *ngIf="selectedOvertimeProject5?.attribute2=='Y'">
                                        <mat-label>Kiracı</mat-label>
                                        <mat-select [(value)]="selectedOvertimeTenant5">
                                            <mat-option *ngFor="let overtimeTenant of overtimeTenantList"
                                                [value]="overtimeTenant">
                                                {{overtimeTenant.description}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="col-lg-2">
                                <mat-form-field style="width: 100%;">
                                    <mat-label>Ad Soyad</mat-label>
                                    <input matInput placeholder="" [(ngModel)]="searchFullName4">
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3 table-header-button-wrapper">
                                <button mat-raised-button color="warn" (click)="filterGrid(3, 'REDDETTIKLERIM')"
                                    style="margin-right: 5px;">Filtrele</button>
                                <button mat-raised-button color="link" (click)="clearfilterGrid(3, 'REDDETTIKLERIM')"
                                    style="margin-right: 5px;">Temizle</button>
                                <div class="excel-export-button" matTooltip="Excele aktar"
                                    (click)="reportTab(3, 'REDDETTIGIM_FAZLA_MESAILER')">
                                    <fa-icon [icon]="fileExcelIcon" class="excel-icon"></fa-icon>
                                </div>
                            </div>
                        </div>

                        <mat-table matTableExporter #exporter4="matTableExporter" [hiddenColumns]="[9]"
                            #RejectSort="matSort" matSort class="lessons-table mat-elevation-z8"
                            [dataSource]="dsRejects" (matSortChange)="sortChangeOfRejects($event)">
                            <ng-container matColumnDef="isCompleted">
                                <mat-header-cell *matHeaderCellDef> Durum </mat-header-cell>
                                <mat-cell *matCellDef="let element" [ngStyle]="{'color' : element.isCompleted == 1 ? 'green' :
                                                              element.isCompleted == -1 ? 'red' :
                                                              'gray'}">
                                    {{element.isCompleted == 1 ? 'Onaylandı' : element.isCompleted == -1 ? 'Reddedildi'
                                    : 'Bekliyor'}}
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="name">
                                <mat-header-cell *matHeaderCellDef mat-sort-header> Adı Soyadı </mat-header-cell>
                                <mat-cell *matCellDef="let element">{{element.name}} {{element.surname}}</mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="departmentName">
                                <mat-header-cell *matHeaderCellDef> Departman </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.departmentName}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="overtimeTypeName">
                                <mat-header-cell *matHeaderCellDef> Mesai Türü </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.overtimeTypeName}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="overtimeDay">
                                <mat-header-cell *matHeaderCellDef style="flex-grow: 0.5"> Mesai <br> Süresi
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element" style="flex-grow: 0.5"> {{element.overtimeHours}}
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="freeDayAmount">
                                <mat-header-cell *matHeaderCellDef style="flex-grow: 0.5"> Tatil <br> Günü
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element" style="flex-grow: 0.5"> {{element.isRestDay == 1 ?
                                    'Evet' : 'Hayır'}}
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="overtimeStartDate">
                                <mat-header-cell *matHeaderCellDef mat-sort-header> Başlangıç </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.overtimeStartDate | customDate}}
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="overtimeEndDate">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>Bitiş </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.overtimeEndDate | customDate}}
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="description">
                                <mat-header-cell *matHeaderCellDef> Açıklama</mat-header-cell>
                                <mat-cell *matCellDef="let element" class="long-text-content"><span
                                        class="text-truncate">{{element.description}}</span> </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="branchName">
                                <mat-header-cell *matHeaderCellDef style="flex-grow: 1.25"> Şube</mat-header-cell>
                                <mat-cell *matCellDef="let element" class="long-text-content" style="flex-grow: 1.25">
                                    <span class="text-truncate">{{element.branchName}}</span> </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="projectName">
                                <mat-header-cell *matHeaderCellDef style="flex-grow: 1.25"> Proje</mat-header-cell>
                                <mat-cell *matCellDef="let element" class="long-text-content" style="flex-grow: 1.25">
                                    <span class="text-truncate">{{element.projectName}}</span> </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="actions">
                                <mat-header-cell *matHeaderCellDef class="actions-mat-cell"></mat-header-cell>
                                <mat-cell *matCellDef="let element" class="actions-mat-cell">
                                    <div class="action-buttons-container">
                                        <button mat-icon-button matTooltip="Detay" class="action-button detail-button"
                                            (click)="openDetail(element)">
                                            <mat-icon>insert_comment</mat-icon>
                                        </button>
                                    </div>
                                </mat-cell>
                            </ng-container>
                            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
                        </mat-table>
                        <mat-paginator [pageSizeOptions]="[20]" (page)="pageEventOfRejects($event)"
                            #rejectsPaginator='matPaginator' showFirstLastButtons></mat-paginator>
                    </div>
                </mat-tab>
                <mat-tab label="Tüm Mesailer" *ngIf="currentUser.manager || currentUser.hr">
                    <div class="table-responsive table-hidden-scroll" style="overflow-x:hidden">

                        <div class="row filter-wrapper">
                            <div class="col-lg-2">
                                <mat-form-field class="overtime-form-field">
                                    <mat-label>Mesai Türü Seçiniz</mat-label>
                                    <mat-select [(value)]="selectedovertimeType5">
                                        <mat-option *ngFor="let overtimeType of overtimeTypeList"
                                            [value]="overtimeType">
                                            {{overtimeType.description}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3">
                                <mat-form-field class="overtime-form-field">
                                    <mat-label>Departman Seçiniz</mat-label>
                                    <mat-select [(value)]="selectedDepartment5">
                                        <mat-option *ngFor="let department of departmentList" [value]="department">
                                            {{department.lookupValue ? (department.lookupValue + ' - ' + department.description) : department.description}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-2">
                                <mat-form-field class="overtime-form-field">
                                    <mat-label>Durum Seçiniz</mat-label>
                                    <mat-select [(value)]="selectedStatu5">
                                        <mat-option *ngFor="let statu of StatuList" [value]="statu">
                                            {{statu.description}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-2">
                                <mat-form-field class="overtime-form-field">
                                    <mat-label>Başlangıç Tarihi</mat-label>
                                    <input readonly matInput [matDatepicker]="pickerStart5"
                                        [formControl]="startDateFilterValue5" style="max-width: 160px;">
                                    <mat-datepicker-toggle matSuffix [for]="pickerStart5"></mat-datepicker-toggle>
                                    <mat-datepicker startView="multi-year" #pickerStart5></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-2">
                                <mat-form-field class="overtime-form-field">
                                    <mat-label>Bitiş Tarihi</mat-label>
                                    <input readonly matInput [matDatepicker]="pickerEnd5"
                                        [formControl]="endDateFilterValue5">
                                    <mat-datepicker-toggle matSuffix [for]="pickerEnd5"></mat-datepicker-toggle>
                                    <mat-datepicker #pickerEnd5 startView="multi-year"></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-2">
                                <div class="form-group">
                                    <mat-form-field class="overtime-form-field">
                                        <mat-label>Şube </mat-label>
                                        <mat-select [(value)]="selectedOvertimeBranch5">
                                            <mat-option *ngFor="let overtimeBranch of overtimeBranchList"
                                                [value]="overtimeBranch">
                                                {{overtimeBranch.description}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="col-lg-2">
                                <div class="form-group">
                                    <mat-form-field class="overtime-form-field">
                                        <mat-label>Proje</mat-label>
                                        <mat-select [(value)]="selectedOvertimeProject5"
                                            (selectionChange)="overtimeProjectChanged()">
                                            <mat-option *ngFor="let overtimeProject of overtimeProjectList"
                                                [value]="overtimeProject">
                                                {{overtimeProject.description}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="col-lg-2" *ngIf="selectedOvertimeProject5?.attribute2=='Y'">
                                <div class="form-group">
                                    <mat-form-field class="overtime-form-field"
                                        *ngIf="selectedOvertimeProject5?.attribute2=='Y'">
                                        <mat-label>Kiracı</mat-label>
                                        <mat-select [(value)]="selectedOvertimeTenant5">
                                            <mat-option *ngFor="let overtimeTenant of overtimeTenantList"
                                                [value]="overtimeTenant">
                                                {{overtimeTenant.description}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="col-lg-2">
                                <mat-form-field style="width: 100%;">
                                    <mat-label>Ad Soyad</mat-label>
                                    <input matInput placeholder="" [(ngModel)]="searchFullName5">
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3 table-header-button-wrapper">
                                <button mat-raised-button color="warn" (click)="filterGrid(4, 'TUMMESAILER')"
                                    style="margin-right: 5px;">Filtrele</button>
                                <button mat-raised-button color="link" (click)="clearfilterGrid(4, 'TUMMESAILER')"
                                    style="margin-right: 5px;">Temizle</button>
                                <div class="excel-export-button" matTooltip="Excele aktar" mat-button
                                    (click)="reportTab(4, 'TUM_FAZLA_MESAILER')">
                                    <fa-icon [icon]="fileExcelIcon" class="excel-icon"></fa-icon>
                                </div>
                            </div>
                        </div>

                        <mat-table matTableExporter #exporter4="matTableExporter" [hiddenColumns]="[9]"
                            #AllSort="matSort" matSort class="lessons-table mat-elevation-z8" [dataSource]="dsAll"
                            (matSortChange)="sortChangeOfAll($event)">
                            <ng-container matColumnDef="isCompleted">
                                <mat-header-cell *matHeaderCellDef> Durum </mat-header-cell>
                                <mat-cell *matCellDef="let element" [ngStyle]="{'color' : element.isCompleted == 1 ? 'green' :
                                                              element.isCompleted == -1 ? 'red' :
                                                              'gray'}">
                                    {{element.isCompleted == 1 ? 'Onaylandı' : element.isCompleted == -1 ? 'Reddedildi'
                                    : 'Bekliyor'}}
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="name">
                                <mat-header-cell *matHeaderCellDef mat-sort-header> Adı Soyadı </mat-header-cell>
                                <mat-cell *matCellDef="let element">{{element.name}} {{element.surname}}</mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="departmentName">
                                <mat-header-cell *matHeaderCellDef> Departman </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.departmentName}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="overtimeTypeName">
                                <mat-header-cell *matHeaderCellDef> Mesai Türü </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.overtimeTypeName}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="overtimeDay">
                                <mat-header-cell *matHeaderCellDef style="flex-grow: 0.5"> Mesai <br> Süresi
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element" style="flex-grow: 0.5"> {{element.overtimeHours}}
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="freeDayAmount">
                                <mat-header-cell *matHeaderCellDef style="flex-grow: 0.5"> Tatil <br> Günü
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element" style="flex-grow: 0.5"> {{element.isRestDay == 1 ?
                                    'Evet' : 'Hayır'}}
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="overtimeStartDate">
                                <mat-header-cell *matHeaderCellDef mat-sort-header> Başlangıç </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.overtimeStartDate | customDate}}
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="overtimeEndDate">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>Bitiş </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.overtimeEndDate | customDate}}
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="description">
                                <mat-header-cell *matHeaderCellDef> Açıklama</mat-header-cell>
                                <mat-cell *matCellDef="let element" class="long-text-content"><span
                                        class="text-truncate">{{element.description}}</span> </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="branchName">
                                <mat-header-cell *matHeaderCellDef style="flex-grow: 1.25"> Şube</mat-header-cell>
                                <mat-cell *matCellDef="let element" class="long-text-content" style="flex-grow: 1.25">
                                    <span class="text-truncate">{{element.branchName}}</span> </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="projectName">
                                <mat-header-cell *matHeaderCellDef style="flex-grow: 1.25"> Proje</mat-header-cell>
                                <mat-cell *matCellDef="let element" class="long-text-content" style="flex-grow: 1.25">
                                    <span class="text-truncate">{{element.projectName}}</span> </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="actions">
                                <mat-header-cell *matHeaderCellDef class="actions-mat-cell">İşlemler</mat-header-cell>
                                <mat-cell *matCellDef="let element" class="actions-mat-cell">
                                    <button *ngIf="(currentUser.hr || currentUser.selectedRole.name === 'ROLE_ADMIN')"
                                        mat-icon-button matTooltip="Güncelle"
                                        class="overtime-iconbutton iconbutton action-button"
                                        (click)="openUpdateModal(element, 5)">
                                        <mat-icon class="overtime-action-icon"
                                            [ngStyle]="{'color': '#1976d2'}">edit</mat-icon>
                                    </button>
                                </mat-cell>
                            </ng-container>
                            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
                        </mat-table>
                        <mat-paginator [pageSizeOptions]="[20]" (page)="pageEventOfAll($event)"
                            #allPaginator="matPaginator" showFirstLastButtons>
                        </mat-paginator>
                    </div>
                </mat-tab>
                <mat-tab label="Raporlar" *ngIf="currentUser.manager || currentUser.hr || currentUser.admin">
                    <div style="overflow-x:hidden">
                        <form [formGroup]="reportForm">
                            <div class="row">
                                <div class="col-lg-3">
                                    <div class="form-group">
                                        <mat-form-field class="overtime-form-field">
                                            <mat-label>Departman Listesi</mat-label>
                                            <mat-select [(value)]="selectedAuthDepartment" formControlName="department"
                                                (selectionChange)="departmentChanged()">
                                                <mat-option *ngFor="let department of authDepartmentList"
                                                    [value]="department">
                                                    {{department.name}}
                                                </mat-option>
                                            </mat-select>
                                            <mat-error
                                                *ngIf="reportForm.controls['department'].hasError('required')">Departman
                                                Seçiniz
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-lg-3">
                                    <div class="form-group">
                                        <mat-form-field class="overtime-form-field">
                                            <mat-label>Çalışan Listesi</mat-label>
                                            <mat-select [(value)]="selectedEmployee" formControlName="employee"
                                                (selectionChange)="overtimeTypeChanged()">
                                                <mat-option [value]="null">Seçiniz</mat-option>
                                                <mat-option *ngFor="let employee of employeeList" [value]="employee">
                                                    {{employee.fullName}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-3">
                                    <div class="form-group">
                                        <mat-form-field class="w-100">
                                            <mat-label>Başlangıç Dönem</mat-label>
                                            <input readonly matInput [matDatepicker]="pickerStart"
                                                formControlName="reportStartDate" placeholder="Başlangıç Dönem">
                                            <mat-datepicker-toggle disabled="false" matSuffix
                                                [for]="pickerStart"></mat-datepicker-toggle>
                                            <mat-datepicker startView="multi-year"
                                                (monthSelected)="setStartDateMonthAndClose($event, pickerStart)"
                                                panelClass="month-picker" #pickerStart></mat-datepicker>
                                        </mat-form-field>
                                        <mat-error
                                            *ngIf="reportForm.controls['reportStartDate'].hasError('required') && reportForm.get('reportStartDate').touched">
                                            Dönem seçiniz
                                        </mat-error>
                                    </div>
                                </div>
                                <div class="col-lg-3">
                                    <div class="form-group">
                                        <mat-form-field class="w-100">
                                            <mat-label>Bitiş Dönem</mat-label>
                                            <input readonly matInput [matDatepicker]="pickerEnd"
                                                formControlName="reportEndDate" placeholder="Bitiş Dönem">
                                            <mat-datepicker-toggle disabled="false" matSuffix
                                                [for]="pickerEnd"></mat-datepicker-toggle>
                                            <mat-datepicker startView="multi-year"
                                                (monthSelected)="setEndDateMonthAndClose($event, pickerEnd)"
                                                panelClass="month-picker" #pickerEnd></mat-datepicker>
                                        </mat-form-field>
                                        <mat-error
                                            *ngIf="reportForm.controls['reportEndDate'].hasError('required') && reportForm.get('reportEndDate').touched">
                                            Dönem seçiniz
                                        </mat-error>
                                    </div>
                                </div>

                                <div class="col-lg-2">
                                    <mat-button-toggle-group name="exportType"
                                        [(ngModel)]="selectedExportType"
                                        formControlName="exportType"
                                        (change)="onExportTypeChange($event)"
                                        class="custom-toggle-group"
                                        aria-label="Export Type">
                                        <mat-button-toggle [value]="'PDF'">
                                            <div class="mat-button-toggle-label-content">
                                                <mat-icon>picture_as_pdf</mat-icon>
                                                <span>PDF</span>
                                            </div>
                                        </mat-button-toggle>
                                        <mat-button-toggle [value]="'EXCEL'">
                                            <div class="mat-button-toggle-label-content">
                                                <mat-icon>description</mat-icon>
                                                <span>EXCEL</span>
                                            </div>
                                        </mat-button-toggle>
                                    </mat-button-toggle-group>

                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-2">
                                    <div class="form-group">
                                        <mat-form-field class="overtime-form-field">
                                            <mat-label>Proje</mat-label>
                                            <mat-select [(value)]="selectedOvertimeProject5"
                                                formControlName="reportProject"
                                                (selectionChange)="overtimeProjectChanged()">
                                                <mat-option *ngFor="let overtimeProject of overtimeProjectList"
                                                    [value]="overtimeProject">
                                                    {{overtimeProject.description}}
                                                </mat-option>
                                            </mat-select>
                                            <mat-error
                                                *ngIf="reportForm.controls['reportProject'].hasError('required')">Proje
                                                Seçiniz
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-lg-2">
                                    <div class="form-group" *ngIf="selectedOvertimeProject5?.attribute2=='Y'">
                                        <mat-form-field class="overtime-form-field"
                                            *ngIf="selectedOvertimeProject5?.attribute2=='Y'">
                                            <mat-label>Kiracı</mat-label>
                                            <mat-select [(value)]="selectedOvertimeTenant5"
                                                formControlName="reportTenant">
                                                <mat-option *ngFor="let overtimeTenant of overtimeTenantList"
                                                    [value]="overtimeTenant">
                                                    {{overtimeTenant.description}}
                                                </mat-option>
                                            </mat-select>
                                            <mat-error
                                                *ngIf="reportForm.controls['reportTenant'].hasError('required')">Kiracı
                                                Seçiniz
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>



                            <div class="col-lg-2">
                                <mat-checkbox formControlName="isRestDay" id="isRestDay" aria-label="description">
                                    Mesai olmayan günleri getir ?
                                </mat-checkbox>
                            </div>
                            <div class="col-lg-2"
                                *ngIf="currentUser.authorities.indexOf('ROLE_ADMIN') >= 0 || currentUser.hr">
                                <mat-checkbox formControlName="isEmployeeReport" id="isEmployeeReport "
                                    aria-label="EmployeeReport ">
                                    Çalışan Raporu
                                </mat-checkbox>
                            </div>
                            <button type="submit" class="btn btn-primary" (click)="getOvertimePaymentReport()">Öğün
                                Hakediş Raporu</button>
                            <button type="submit" class="btn btn-primary" style="margin-left: 2px;"
                                (click)="getOvertimeReport()">Fazla Mesai
                                Raporu</button>
                        </form>
                    </div>
                </mat-tab>
            </mat-tab-group>

        </div>
    </div>
</div>